const DAY_IN_MILLIS = 24 * 60 * 60 * 1000;

/** Ranges up to this length get time-of-day axis labels. */
export const INTRADAY_RANGE_IN_MILLIS = DAY_IN_MILLIS * 2;
// Beyond ~11 months the first and last month names wrap around, so labels need the year.
const DATE_RANGE_IN_MILLIS = DAY_IN_MILLIS * 335;

const INTRADAY_LABEL_FORMATTER = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
});
const DATE_LABEL_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
});
const LONG_RANGE_LABEL_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  year: '2-digit',
});

const INTRADAY_CROSSHAIR_LABEL_FORMATTER = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit',
});
const DATE_TIME_CROSSHAIR_LABEL_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});
const LONG_RANGE_CROSSHAIR_LABEL_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: '2-digit',
});

/** Formats a time-series timestamp according to the total visible range. */
export const formatTimeSeriesTimestamp = (timestamp: number, range: number) => {
  if (range <= INTRADAY_RANGE_IN_MILLIS) {
    const date = new Date(timestamp);
    const isMidnight = date.getHours() === 0 && date.getMinutes() === 0;
    return (isMidnight ? DATE_LABEL_FORMATTER : INTRADAY_LABEL_FORMATTER).format(timestamp);
  }

  const formatter =
    range <= DATE_RANGE_IN_MILLIS ? DATE_LABEL_FORMATTER : LONG_RANGE_LABEL_FORMATTER;
  return formatter.format(timestamp);
};

/** Formats a hovered timestamp with more precision than the regular axis ticks. */
export const formatTimeSeriesCrosshairTimestamp = (timestamp: number, range: number) => {
  if (range <= DAY_IN_MILLIS * 2) {
    return INTRADAY_CROSSHAIR_LABEL_FORMATTER.format(timestamp);
  }

  const formatter =
    range <= DAY_IN_MILLIS * 60
      ? DATE_TIME_CROSSHAIR_LABEL_FORMATTER
      : LONG_RANGE_CROSSHAIR_LABEL_FORMATTER;
  return formatter.format(timestamp);
};
